<template>
  <div class="home">
    <b-card>
      <div slot="header">
          <i class="fa fa-thumb-tack" aria-hidden="true"></i>
            ระบบ Admin console version 1.0
          <div class="card-header-actions">
            <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
              <small class="text-muted">docs</small>
            </a>
          </div>
      </div>
      <div class="welcome">
        <p>{{text.welcome}}</p>
        <a href="/docs" target="_blank">{{text.doc}}</a>
      </div>
    </b-card>
  </div>
</template>

<script>
// @ is an alias to /src
import { textHome } from '../assets/utils/language';

export default {
  name: 'home',
  data () {
    return { EnvParam: 'development', text: '' };
  },
  methods: {
    setEnvParamFromUrl () {
      this.EnvParam = window.location.hash.split('#')[1] ? window.location.hash.split('#')[1] : 'development';
    }
  },
  watch: {
    $route: function () {
      this.setEnvParamFromUrl();
    },
    $language: function () {
      this.text = textHome(this.$language);
    }
  },
  created: function () {
    this.setEnvParamFromUrl();
  },
  mounted () {
    this.text = textHome(this.$language);
  }
};
</script>

<style scoped>
  .welcome{
    text-align: center;
  }
</style>
